
import React from 'react';
import SEO from '@/components/SEO';
import Navigation from '@/components/Navigation';
import Footer from '@/components/Footer';
import Hero from '@/components/Hero';
import IntroSection from '@/components/data-platform/IntroSection';
import MethodologySection from '@/components/data-platform/MethodologySection';
import ProcessSection from '@/components/data-platform/ProcessSection';

const DataPlatform = () => {
  return (
    <div className="flex flex-col min-h-screen">
      <SEO
        title="Data Platform | Stratodata"
        description="We design and build scalable data platforms for retail — Google BigQuery, modern data stack, automated pipelines and self-service analytics."
        canonical="/services/data-platform"
      />
      <Navigation />
      
      <Hero 
        title="Tailored Organisational Data Platform"
        subtitle="Elevate your organization to data-driven operations with our structured approach that guides you from use case definition to implementation and adoption."
        ctaText="Start Your Data Journey"
        ctaLink="/tell-me-more"
        showSwitchingText={false}
      />
      
      <IntroSection />
      <MethodologySection />
      <ProcessSection />

      <Footer />
    </div>
  );
};

export default DataPlatform;
